import Tags from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Tags';
import { createFiltersFormatter } from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Tags/helpers';
import { getFiltersByKeysWithValues } from '@framework/ui/Organisms/Filters/helpers';
import { allowedToRemoveFilters, filtersKeys } from './constants';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { TradeSideLabelMap, TradeStatusLabelMap } from '@/creditflowresearch/ui/components/trace/contants';

const filtersFormatter = createFiltersFormatter({
  tradeSideLabelMap: TradeSideLabelMap,
  tradeStatusLabelMap: TradeStatusLabelMap,
});

const TraceSidebarTagsContainer = (props) => {
  const { dateFromMin } = useTraceFiltersContext();

  return (
    <Tags
      { ...props }
      filters={ getFiltersByKeysWithValues({ filtersState: props.filters, filtersKeys, dateFromMin }) }
      filtersFormatter={ filtersFormatter }
      allowedToRemoveFilters={ allowedToRemoveFilters }
      filterFormatterData={ props.filters.tradeDate }
    />
  );
};

export default TraceSidebarTagsContainer;
